// extracted by mini-css-extract-plugin
export var contrastLow = "_j-1";
export var externalLink = "_j-2";
export var externalLinkIcon = "_j-3";
export var link = "_j-0";
export var linkLabel = "_j-4";